import { render, staticRenderFns } from "./kost_list.vue?vue&type=template&id=11fc1b5f&scoped=true&"
import script from "./kost_list.vue?vue&type=script&lang=js&"
export * from "./kost_list.vue?vue&type=script&lang=js&"
import style0 from "./kost_list.vue?vue&type=style&index=0&id=11fc1b5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fc1b5f",
  null
  
)

export default component.exports